import React, { useEffect, useState, useRef } from "react";
import { FaEye, FaEdit } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import Filtro from "./FiltroTarjeta";
import useEscClose from "../../useEscClose";
import VerTarjeta from "./VerTarjeta";
import EditarTarjeta from "./EditarTarjeta";
import { appFetchJson } from "../../../utils/http";

const ListaTarjetas = () => {

const fmtMiles = (v) =>
  v === null || v === undefined || v === ""
    ? "—"
    : Number(v).toLocaleString("es-ES");


  const [tarjetas, setTarjetas] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [tarjetasPorPagina, setTarjetasPorPagina] = useState(30);
  const [cargando, setCargando] = useState(false);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => {
    setMostrarFiltros(false);
    document.activeElement?.blur();
  }, mostrarFiltros);

  const [showVer, setShowVer] = React.useState(false);
  const [tarjetaSel, setTarjetaSel] = React.useState(null);
  useEscClose(() => {
    setShowVer(false);
    document.activeElement?.blur();
  }, setShowVer);

  const [showEdit, setShowEdit] = React.useState(false);
  const [tarjetaEdit, setTarjetaEdit] = React.useState(null);
  useEscClose(() => {
    setShowEdit(false);
    document.activeElement?.blur();
  }, showEdit);

  // filtros persistentes para rehidratar el drawer
  const [filtros, setFiltros] = useState({
    numeroTarjeta: [],
    clienteCodigo: "",
    estado: "",
    vehiculoId: "",
    vehiculoEtiqueta: "",
    codigoEESS: "",
    fechaAlta: "",
    fechaBaja: "",
    fechaVigenciaInicio: "",
    fechaVigenciaFin: "",
     centroCosto: "", 
  });

  const [totalElementos, setTotalElementos] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(0);

  const devRunRef = useRef(false);

  // =========== Fetch listado ===========
  const obtenerTarjetas = async (
    pageIndex = 0,
    size = tarjetasPorPagina,
    filtrosArg = filtros,
  ) => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      params.set("page", pageIndex);
      params.set("size", size);

      if (
        Array.isArray(filtrosArg.numeroTarjeta) &&
        filtrosArg.numeroTarjeta.length === 1
      ) {
        params.set("numero", filtrosArg.numeroTarjeta[0]);
      }
      if (filtrosArg.clienteCodigo && filtrosArg.clienteCodigo.trim() !== "") {
        params.set("clienteCodigo", filtrosArg.clienteCodigo.trim());
      }
      if (filtrosArg.estado && String(filtrosArg.estado).trim() !== "") {
        params.set("estadoId", String(filtrosArg.estado).trim());
      }
      if (
        filtrosArg.vehiculoId &&
        String(filtrosArg.vehiculoId).trim() !== ""
      ) {
        params.set("vehiculoId", String(filtrosArg.vehiculoId).trim());
      }
      if (filtrosArg.codigoEESS)
        params.set("eessCodigoEstacion", filtrosArg.codigoEESS.trim());

      // 👇 fechas (el backend espera dataFecha*)
      if (filtrosArg.fechaAlta)
        params.set("dataFechaAlta", filtrosArg.fechaAlta);
      if (filtrosArg.fechaBaja)
        params.set("dataFechaBaja", filtrosArg.fechaBaja);
      if (filtrosArg.fechaVigenciaInicio)
        params.set("dataFechaVigenciaIni", filtrosArg.fechaVigenciaInicio);
      if (filtrosArg.fechaVigenciaFin)
        params.set("dataFechaVigenciaFin", filtrosArg.fechaVigenciaFin);
      //nuevo filtro
if (filtrosArg.centroCosto && filtrosArg.centroCosto.trim() !== "") {
  params.set("dataCentroCosto", filtrosArg.centroCosto.trim());
}

      const data = await appFetchJson(
        `${apiRoutes.tarjetas.list}?${params.toString()}`,
      );

      const items = data?.items || data?.content || [];
      const total = Number.isFinite(data?.totalElements)
        ? data.totalElements
        : Number.isFinite(data?.total)
          ? data.total
          : items.length;

      setTarjetas(items);
      setTotalElementos(total);
      setTotalPaginas(
        Number.isFinite(data?.totalPages)
          ? data.totalPages
          : Math.max(1, Math.ceil(total / (size || 1))),
      );
    } catch (error) {
      console.error("Error al cargar tarjetas:", error);
      setTarjetas([]);
      setTotalElementos(0);
      setTotalPaginas(0);
    } finally {
      setCargando(false);
    }
  };

  // Multi-búsqueda por varios números
  // Multi-búsqueda por varios números
  const obtenerTarjetasMulti = async (filtrosArg) => {
    setCargando(true);
    try {
      const resultados = [];
      for (const num of filtrosArg.numeroTarjeta || []) {
        const params = new URLSearchParams();
        params.set("page", 0);
        params.set("size", tarjetasPorPagina);
        params.set("numero", num);

        if (filtrosArg.clienteCodigo)
          params.set("clienteCodigo", filtrosArg.clienteCodigo.trim());
        if (filtrosArg.estado)
          params.set("estadoId", String(filtrosArg.estado).trim());
        if (filtrosArg.vehiculoId)
          params.set("vehiculoId", String(filtrosArg.vehiculoId).trim());
        if (filtrosArg.codigoEESS)
          params.set("eessCodigoEstacion", filtrosArg.codigoEESS.trim());

        // ✅ fechas (faltaban estas dos líneas de vigencia)
        if (filtrosArg.fechaAlta)
          params.set("dataFechaAlta", filtrosArg.fechaAlta);
        if (filtrosArg.fechaBaja)
          params.set("dataFechaBaja", filtrosArg.fechaBaja);
        if (filtrosArg.fechaVigenciaInicio)
          params.set("dataFechaVigenciaIni", filtrosArg.fechaVigenciaInicio);
        if (filtrosArg.fechaVigenciaFin)
          params.set("dataFechaVigenciaFin", filtrosArg.fechaVigenciaFin);

        //Nuevo
        if (filtrosArg.centroCosto && filtrosArg.centroCosto.trim() !== "") {
  params.set("dataCentroCosto", filtrosArg.centroCosto.trim());
}

        const data = await appFetchJson(
          `${apiRoutes.tarjetas.list}?${params.toString()}`,
        );
        const items = data?.items ?? data?.content ?? [];
        resultados.push(...items);
      }
      const unicos = resultados.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i,
      );
      setTarjetas(unicos);
      setTotalElementos(unicos.length);
      setTotalPaginas(1);
    } catch (error) {
      console.error(error);
      setTarjetas([]);
      setTotalElementos(0);
      setTotalPaginas(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      if (!devRunRef.current) {
        devRunRef.current = true;
        return;
      }
    }
    obtenerTarjetas(0, tarjetasPorPagina, filtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const manejarCambioCantidad = (e) => {
    const nuevoSize = Number(e.target.value);
    setTarjetasPorPagina(nuevoSize);
    setPaginaActual(1);
    obtenerTarjetas(0, nuevoSize, filtros);
  };

  const toggleFiltros = () => setMostrarFiltros(!mostrarFiltros);

  // Aplicación “en vivo” al quitar chips
  const handleFiltroChange = (snapshot) => {
    if (!snapshot || typeof snapshot !== "object") return;
    const next = { ...filtros, ...snapshot };
    setFiltros(next);

    const n = Array.isArray(next.numeroTarjeta) ? next.numeroTarjeta.length : 0;
    if (n > 1) {
      obtenerTarjetasMulti(next);
    } else {
      obtenerTarjetas(0, tarjetasPorPagina, next);
    }
  };

  const handleFiltroSubmit = (payload) => {
    // si vino vacío, reseteo y cierro
    if (!payload || Object.keys(payload).length === 0) {
      limpiarSeleccion();
      setMostrarFiltros(false);
      return;
    }

    const nuevosFiltros = { ...filtros, ...payload };
    setFiltros(nuevosFiltros);
    setPaginaActual(1);

    if (
      Array.isArray(nuevosFiltros.numeroTarjeta) &&
      nuevosFiltros.numeroTarjeta.length > 1
    ) {
      obtenerTarjetasMulti(nuevosFiltros);
    } else {
      obtenerTarjetas(0, tarjetasPorPagina, nuevosFiltros);
    }
    setMostrarFiltros(false);
  };

  const cambiarPagina = (num) => {
    if (num >= 1 && num <= totalPaginas) {
      setPaginaActual(num);
      obtenerTarjetas(num - 1, tarjetasPorPagina, filtros);
    }
  };

  const limpiarSeleccion = () => {
    const filtrosLimpios = {
      numeroTarjeta: [],
      clienteCodigo: "",
      estado: "",
      vehiculoId: "",
      vehiculoEtiqueta: "",
      codigoEESS: "",
      fechaAlta: "",
      fechaBaja: "",
      fechaVigenciaInicio: "",
      fechaVigenciaFin: "",
      centroCosto: "",
    };
    setFiltros(filtrosLimpios);
    setPaginaActual(1);
    obtenerTarjetas(0, tarjetasPorPagina, filtrosLimpios);
  };

  // 👇 AHORA incluye fechas para que aparezca el botón “Limpiar Selección”
  const hayFiltros =
    (Array.isArray(filtros.numeroTarjeta) &&
      filtros.numeroTarjeta.length > 0) ||
    (!!filtros.clienteCodigo && filtros.clienteCodigo.trim() !== "") ||
    (!!filtros.estado && String(filtros.estado).trim() !== "") ||
    (!!filtros.vehiculoId && String(filtros.vehiculoId).trim() !== "") ||
    (!!filtros.codigoEESS && filtros.codigoEESS.trim() !== "") ||
    (!!filtros.fechaAlta && filtros.fechaAlta.trim() !== "") ||
    (!!filtros.fechaBaja && filtros.fechaBaja.trim() !== "") ||
    (!!filtros.fechaVigenciaInicio &&
      filtros.fechaVigenciaInicio.trim() !== "") ||
    (!!filtros.fechaVigenciaFin && filtros.fechaVigenciaFin.trim() !== "") ||
    (!!filtros.centroCosto && filtros.centroCosto.trim() !== "");

  const inicioMostrado =
    totalElementos === 0 ? 0 : (paginaActual - 1) * tarjetasPorPagina + 1;
  const finMostrado = Math.min(
    paginaActual * tarjetasPorPagina,
    totalElementos,
  );

  const camposFiltro = [
    {
      name: "numeroTarjeta",
      label: "Nro. de Tarjeta",
      tipo: "text",
      placeholder: "Buscar por número...",
    },
    { name: "estado", label: "Estado", tipo: "text", placeholder: "Estado" },
  ];

  return (
    <div className="page">
      <h1 className="page-title">💳 Lista de Tarjetas</h1>

      <div className="toolbar">
        <div className="inline-flex items-center gap-2">
          <button onClick={toggleFiltros} className="btn-fil">
            {mostrarFiltros ? "Ocultar Filtros" : "Ver Filtros"}
          </button>
          {hayFiltros && (
            <button onClick={limpiarSeleccion} className="btn-fil">
              Limpiar Selección
            </button>
          )}
        </div>
      </div>

      {mostrarFiltros && (
        <Filtro
          campos={camposFiltro}
          initialValues={filtros}
          onChange={handleFiltroChange}
          onSubmit={handleFiltroSubmit}
          onClose={toggleFiltros}
        />
      )}

      <div className="control-block">
        <label htmlFor="cantidadPorPagina" className="label-strong">
          Mostrar por página:
        </label>
        <select
          id="cantidadPorPagina"
          value={tarjetasPorPagina}
          onChange={manejarCambioCantidad}
          className="select"
        >
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>

      <div className="overflow-x-auto">
        <table className="table-card table-sm">
          <thead className="table-head">
            <tr>
              <th className="cell">Nro. de Tarjeta</th>
              <th className="cell">Cliente</th>
              
              <th className="cell">Fecha Inicio</th>
              <th className="cell">Fecha Final</th>
              <th className="cell">Saldo</th>
              <th className="cell">Límite</th>
              <th className="cell" style={{ textAlign: 'left', paddingLeft: '0.5rem' }}>Ctro. Costo</th>
              <th className="cell">Estado</th>
              <th className="cell">N° de chapa</th>
              <th className="cell-center">Acción</th>
            </tr>
          </thead>
          <tbody>
            {cargando ? (
              <tr>
                <td colSpan="11" className="cell-center py-4">
                  Cargando...
                </td>
              </tr>
            ) : tarjetas.length === 0 ? (
              <tr>
                <td colSpan="11" className="cell-center text-gray-500 py-4">
                  Ningún resultado encontrado.
                </td>
              </tr>
            ) : (
              tarjetas.map((t, index) => (
                <tr key={index} className="row-border">
                  <td className="cell">{t.numero}</td>
                  <td className="cell">{t.clienteNombre}</td>
                
                  <td className="cell">{t.dataFechaVigenciaIni}</td>
                  <td className="cell">{t.dataFechaVigenciaFin}</td>
                  <td className="cell">{fmtMiles(t.valorSaldo)}</td>
                  <td className="cell">{fmtMiles(t.valorLimite)}</td>
                  <td className="cell">{t.dataCentroCosto}</td>
                  <td className="cell">{t.estadoNombre}</td>
                  <td className="cell">{t.chapa}</td>
                  <td className="cell-center space-x-2">
                    <button
                      type="button"
                      className="icon-btn"
                      title="Ver"
                      onClick={(e) => {
                        e.stopPropagation();
                        setTarjetaSel(t);
                        setShowVer(true);
                      }}
                    >
                      <FaEye />
                    </button>
                    <button
                      type="button"
                      className="icon-btn"
                      title="Editar"
                      onClick={(e) => {
                        e.stopPropagation();
                        setTarjetaEdit(t);
                        setShowEdit(true);
                      }}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4 text-sm text-gray-600">
        {`${totalElementos.toLocaleString("es-ES")} item${totalElementos !== 1 ? "s" : ""} encontrados, mostrando de ${inicioMostrado} a ${finMostrado}.`}
      </div>

      <nav className="pager">
        <button
          onClick={() => cambiarPagina(1)}
          disabled={paginaActual === 1}
          className={paginaActual === 1 ? "pager-off" : "pager-btn"}
        >
          Primera
        </button>
        <button
          onClick={() => cambiarPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
          className={paginaActual === 1 ? "pager-off" : "pager-btn"}
        >
          Anterior
        </button>

        {[...Array(totalPaginas)].map((_, i) => {
          const num = i + 1;
          if (
            num === 1 ||
            num === totalPaginas ||
            (num >= paginaActual - 2 && num <= paginaActual + 2)
          ) {
            return (
              <button
                key={num}
                onClick={() => cambiarPagina(num)}
                className={paginaActual === num ? "pager-active" : "pager-btn"}
              >
                {num}
              </button>
            );
          }
          if (num === paginaActual - 3 || num === paginaActual + 3) {
            return (
              <span key={num} className="px-2 py-1">
                …
              </span>
            );
          }
          return null;
        })}

        <button
          onClick={() => cambiarPagina(paginaActual + 1)}
          disabled={paginaActual === totalPaginas || totalPaginas === 0}
          className={
            paginaActual === totalPaginas || totalPaginas === 0
              ? "pager-off"
              : "pager-btn"
          }
        >
          Próxima
        </button>
        <button
          onClick={() => cambiarPagina(totalPaginas)}
          disabled={paginaActual === totalPaginas || totalPaginas === 0}
          className={
            paginaActual === totalPaginas || totalPaginas === 0
              ? "pager-off"
              : "pager-btn"
          }
        >
          Última
        </button>
      </nav>

      {showVer && (
        <VerTarjeta tarjeta={tarjetaSel} onClose={() => setShowVer(false)} />
      )}
      {showEdit && (
        <EditarTarjeta
          tarjeta={tarjetaEdit}
          onClose={() => setShowEdit(false)}
          onSaved={(updated) => {
            setTarjetas((prev) =>
              prev.map((x) =>
                (x.id ?? x.numero) === (updated.id ?? updated.numero)
                  ? { ...x, ...updated }
                  : x,
              ),
            );
          }}
        />
      )}
    </div>
  );
};

export default ListaTarjetas;
